enum OfferTypes {
  coupon = "COUPON",
  promotion = "PROMOTION",
}

export default OfferTypes;
